import React, { useCallback } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import "./App.css";
import { useState, useEffect, useContext, Suspense, useRef } from "react";
import WebSocketInstance from "./common/WebSocketInstance";
import RequireAuth from "./RequireAuth";
import axios from "axios";
import SessionTimeoutModal from "./app/components/SessionTimeoutModal/SessionTimeoutModal";
import SessionDisconnectedModal from "./app/components/SessionDisconnectedModal/SessionDisconnectedModal";
import { onSessionDisconnected, forceLogout } from "./common/tokenRefresh";
import context, { ContextType } from "./store/create-context";
import api, {
  acceptTerms,
  BillingSubscriptionsOverviewResponse,
  getBillingSubscriptionsOverview,
} from "./common/api";
// import InPress from "./app/components/newLandingPages/InPress/inPress";
// import Blogs from "./app/components/newLandingPages/blogs/Blogs";
// import NewProductPage from "./app/components/newLandingPages/newProductPage/components/NewProductPage";
// import ProductPage from "./app/components/newLandingPages/Products/Deprecated/productIndex";
// import NewArchProductPage from "./app/components/newLandingPages/Products/Deprecated/NewArch";
// import BrochuresIndex from "./app/components/newLandingPages/brochures/brochuresIndex";
// import FlyersIndex from "./app/components/newLandingPages/flyers/flyersIndex";
// import NewBlogs from "./app/components/newLandingPages/blogs/NewBlogs";
// import Details from "./app/components/newLandingPages/detailPage/Details";
import TermsModal from "./app/components/signup/TermsModal";
// import NewBlog1 from "./app/components/newLandingPages/blogs/NewBlog1";
// import NewBlog2 from "./app/components/newLandingPages/blogs/NewBlog2";
import { v4 as uuidv4 } from "uuid";
import { SResponse } from "./app/components/new-canvas/types/SResponse";
import { ClickRumTracker } from "./utils/aws-app-monitor/ClickRumTracker";
import { PageTimeRumTracker } from "./utils/aws-app-monitor/PageTimeRumTracker";
import { PublicCanvasRumTracker } from "./utils/aws-app-monitor/PublicCanvasRumTracker";
import {
  loginRumTracker,
  logoutRumTracker,
} from "./utils/aws-app-monitor/ActiveUserRumTracker";
import VisibilityPersistence from "./VisibilityPersistence";
import SpinnerLoader from "./common/components/SpinnerLoader/SpinnerLoader";
import {
  authSync,
  AuthSyncEvent,
  UserSessionData,
  clearHasAcceptedTermsFromStorage,
  readHasAcceptedTermsFromStorage,
  writeHasAcceptedTermsToStorage,
} from "./common/publicUtils";
import { useInactivityTimeout } from "./app/utils/useInactivityTimeout";
import NewLandingPage from "./app/updatedLandingPage/NewLandingPage";
import {
  LOGIN_ENABLED,
  shouldRedirectHomeWhileLoginDisabled,
} from "./common/loginAvailability";
import MaintenanceBanner from "./common/components/MaintenanceBanner/MaintenanceBanner";

const RouteFallback = () => (
  <div style={{ minHeight: "100vh", background: "black" }} />
);

const POST_LOGIN_REDIRECT_KEY = "postLoginRedirect";

const getSafePostLoginRedirect = (candidate: unknown): string | null =>
  typeof candidate === "string" &&
  candidate.startsWith("/") &&
  !candidate.startsWith("//")
    ? candidate
    : null;

const NewDashboard = React.lazy(() => import("./app/NewDashboard/NewDashboard"));
const RedriveIndexingPage = React.lazy(
  () => import("./app/components/admintools/RedriveIndexingPage"),
);
const NewSafeViewEditArchitecture = React.lazy(
  () =>
    import(
      "./app/components/new-view-edit-architecture/new-safe-view-edit-architecture"
    ),
);
const PageNotFound = React.lazy(() => import("./PageNotFound"));
const SWArchVisualizerProductPage = React.lazy(
  () =>
    import(
      "./app/components/newLandingPages/Products/SWArchVisualizer/SWArchVisualizer"
    ),
);
const CloudScannerProductPage = React.lazy(
  () =>
    import("./app/components/newLandingPages/Products/CloudScanner/CloudScanner"),
);
const GithubAppProductPage = React.lazy(
  () =>
    import("./app/components/newLandingPages/Products/GithubApp/GithubApp"),
);
const GovernanceProductPage = React.lazy(
  () =>
    import("./app/components/newLandingPages/Products/Governance/Governance"),
);
const VibeCodeCheckProductPage = React.lazy(
  () =>
    import(
      "./app/components/newLandingPages/Products/VibeCodeCheck/VibeCodeCheck"
    ),
);
const CloudScannerUserGuide = React.lazy(
  () =>
    import(
      "./app/components/newLandingPages/Products/CloudScanner/CloudScannerUserGuide"
    ),
);
const DemoPage = React.lazy(
  () => import("./app/components/newLandingPages/demoPage/DemoPage"),
);
const OpenSourceProjects = React.lazy(
  () =>
    import("./app/components/newLandingPages/openSourceProjects/OpenSourceProjects"),
);
const OpenSourceProjectPage = React.lazy(
  () =>
    import("./app/components/newLandingPages/openSourceProjects/ProjectPage"),
);
const JigsawAiPage = React.lazy(
  () => import("./app/components/newLandingPages/jigsawAi/JigsawAiPage"),
);
const PricingPage = React.lazy(
  () =>
    import("./app/components/newLandingPages/pricing/PricingPage"),
);
const NewInPress = React.lazy(
  () => import("./app/components/newLandingPages/InPress/NewInPress"),
);
const SignInPage = React.lazy(() => import("./app/components/login/SignInPage"));
const SignupPage = React.lazy(() => import("./app/components/signup/SignupPage"));
const SignupConfirm = React.lazy(
  () => import("./app/components/signup/SignupConfirm"),
);
const ResetPassword = React.lazy(
  () => import("./app/components/managepassword/ResetPassword"),
);
const ForgotPassword = React.lazy(
  () => import("./app/components/managepassword/ForgotPassword"),
);
const ChangePassword = React.lazy(
  () => import("./app/components/managepassword/ChangePassword"),
);
const StartPage = React.lazy(
  () => import("./app/components/getStarted/StartPage"),
);
const InstallerPage = React.lazy(
  () => import("./app/components/installer/InstallerPage"),
);
const InstallerDownloadSuccess = React.lazy(
  () => import("./app/components/installerStatus/InstallerDownloadSuccess"),
);
const InstallerDownloadError = React.lazy(
  () => import("./app/components/installerStatus/InstallerDownloadError"),
);
const InstallerDownloadGeneralError = React.lazy(
  () => import("./app/components/installerStatus/InstallerDownloadGeneralError"),
);

declare global {
  interface Window {
    reb2b: any;
  }
}

export const isLocalInstaller = () => {
  return process.env.REACT_APP_ENVIRONMENT === "binary";
};

export const isCloudDB = () => {
  return process.env.REACT_APP_STORAGE_ENVIRONMENT === "cloud_db";
};

export {};

function App() {
  // const events: string[] = useMemo(
  //   () => ["load", "mousemove", "mousedown", "click", "scroll", "keypress"],
  //   [],
  // );
  const [sResponse, setSResponse] = useState<SResponse | null>(null);
  // Stable identity is required: consumers (e.g. NewSafeViewEditArchitecture's
  // unmount cleanup) key effects on this setter, so an inline wrapper would
  // re-trigger them on every render and wipe sResponse.
  const setSResponseSafe = useCallback(
    (value: React.SetStateAction<SResponse | null | undefined>) => {
      setSResponse((prev) => {
        const nextValue = typeof value === "function" ? value(prev) : value;
        return nextValue ?? null;
      });
    },
    [],
  );
  const [qResponse, setQResponse] = useState<Record<string, any>>({});
  const [, setPromptFixed] = useState<boolean>(false);
  const [, setWaitingForResponse] = useState<boolean>(false);
  const [descriptionId] = useState<string>("");
  const [socket, setSocket] = useState<WebSocketInstance | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [hasAcceptedTerms, setHasAcceptedTerms] = useState<boolean>(() =>
    readHasAcceptedTermsFromStorage(),
  );
  const [isAcceptingTerms, setIsAcceptingTerms] = useState<boolean>(false);
  const [showSessionDisconnected, setShowSessionDisconnected] =
    useState<boolean>(false);
  const [loadingArch, setLoadingArch] = useState<boolean>(false);
  const [authToken, setAuthToken] = useState<string | null>(null);
  const [passwordChangeResponse, setPasswordChangeResponse] = useState<any>();
  const {
    setProjects,
    setUserId,
    setShowToastr,
    openSpinnerHandler,
    closeSpinnerHandler,
    setLogoutHandler,
  } = useContext<ContextType | any>(context);
  const isDevEnvironment = process.env.REACT_APP_ENVIRONMENT === "dev";
  const location = useLocation();
  const loginStatePath = (location.state as { path?: unknown } | null)?.path;
  const loginRedirect =
    getSafePostLoginRedirect(loginStatePath) ??
    getSafePostLoginRedirect(
      sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY),
    ) ??
    "/dashboard";

  useEffect(() => {
    if (isAuthenticated && location.pathname !== "/login") {
      sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
    }
  }, [isAuthenticated, location.pathname]);

  const shouldShowFreePlanNudge = useCallback(
    (overviewPayload: BillingSubscriptionsOverviewResponse): boolean => {
      const allSubscriptionScopes = [
        overviewPayload.individual_subscription,
        ...overviewPayload.business_subscriptions,
      ];

      const hasAnyActivePaidSubscription = allSubscriptionScopes.some(
        (subscriptionItem) => {
          const normalizedState = (subscriptionItem.subscription_state || "")
            .trim()
            .toLowerCase();
          return subscriptionItem.is_paid_plan && normalizedState === "active";
        },
      );

      if (hasAnyActivePaidSubscription) {
        return false;
      }

      return !overviewPayload.has_active_team_plan;
    },
    [],
  );

  const maybeShowFreePlanNudge = useCallback(async (): Promise<void> => {
    try {
      const billingOverviewResponse = await getBillingSubscriptionsOverview();
      if (!billingOverviewResponse.data?.success) {
        return;
      }

      if (!shouldShowFreePlanNudge(billingOverviewResponse.data)) {
        return;
      }

      setShowToastr({
        show: true,
        type: "warning",
        text: (
          <span>
            You are currently on the free plan. Upgrade immediately to unlock premium benefits and avoid disruptions. {" "}
            <a
              href="/pricing"
              style={{ color: "inherit", textDecoration: "underline", fontWeight: 600 }}
            >
              View Plans
            </a>
            .
          </span>
        ),
      });
    } catch (_error) {
      // Best-effort UX nudge; do not interrupt login/signup flow if billing lookup fails.
    }
  }, [setShowToastr, shouldShowFreePlanNudge]);

  // Stable ref so handleAuthEvent (declared below) can call the hook's sync handler
  const handleSyncEventRef = useRef<(type: string) => void>(() => {});

  const handleAuthEvent = useCallback(
    (event: AuthSyncEvent) => {
      const { type } = event;
      const path = window.location.pathname;

      if (type === "FORCE_LOGOUT_PERSONAL") {
        localStorage.removeItem("JMLAuthToken");
        localStorage.removeItem("JMLRefreshToken");
        localStorage.removeItem("userId");
        localStorage.removeItem("SESSION_TYPE");
        clearHasAcceptedTermsFromStorage();

        setAuthToken(null);
        setUserId(null);
        setIsAuthenticated(false);
        setHasAcceptedTerms(false);
        WebSocketInstance.getInstance().close();
        setSocket(null);

        // Only redirect if NOT on a public canvas or projects list
        if (path !== "/login" && !path.startsWith("/open-source-projects")) {
          const match = path.match(/\/canvas\/([^/]+)/);
          const slug = match?.[1];
          if (slug) {
            import("./common/publicUtils").then(({ isPublicSlug }) => {
              if (!isPublicSlug(slug)) window.location.href = "/login";
            });
          } else {
            window.location.href = "/login";
          }
        }
      }

      if (type === "FORCE_LOGOUT_PUBLIC") {
        localStorage.removeItem("JMLPublicToken");
        localStorage.removeItem("JMLPublicTokenExpiry");
        localStorage.removeItem("SESSION_TYPE");

        if (path.match(/\/canvas\/([^/]+)/)) {
          window.location.href = "/open-source-projects";
        }
      }
      handleSyncEventRef.current(type);
    },
    [setAuthToken, setUserId, setIsAuthenticated, setSocket],
  );

  const switchToUserSession = useCallback(
    (token: string, userId: string, data: UserSessionData) => {
      localStorage.setItem("SESSION_TYPE", "USER");
      localStorage.removeItem("JMLPublicToken");
      localStorage.removeItem("JMLPublicTokenExpiry");
      authSync.broadcast({ type: "FORCE_LOGOUT_PUBLIC" });
      handleAuthEvent({ type: "FORCE_LOGOUT_PUBLIC", timestamp: Date.now() });
      localStorage.setItem("JMLAuthToken", token);
      localStorage.setItem("userId", userId);
      if (data.email) localStorage.setItem("JMLEmail", data.email);
      if (data.firstname) localStorage.setItem("JMLFirstname", data.firstname);
      if (data.lastname) localStorage.setItem("JMLLastname", data.lastname);
      if (data.refresh_token)
        localStorage.setItem("JMLRefreshToken", data.refresh_token);
      if (data.auth_provider)
        localStorage.setItem("authProvider", data.auth_provider);
      const termsAccepted = data.has_accepted_terms === true;
      writeHasAcceptedTermsToStorage(termsAccepted);
      setHasAcceptedTerms(termsAccepted);
      setAuthToken(token);
      setUserId(userId);
      setIsAuthenticated(true);
      loginRumTracker();
      WebSocketInstance.getInstance().close();
      const socket = WebSocketInstance.getInstance();
      setSocket(socket);
      void maybeShowFreePlanNudge();
    },
    [
      handleAuthEvent,
      maybeShowFreePlanNudge,
      setAuthToken,
      setUserId,
      setIsAuthenticated,
      setSocket,
    ],
  );

  const switchToPublicSession = useCallback(async () => {
    localStorage.setItem("SESSION_TYPE", "PUBLIC");
    authSync.broadcast({ type: "FORCE_LOGOUT_PERSONAL" });
    handleAuthEvent({ type: "FORCE_LOGOUT_PERSONAL", timestamp: Date.now() });
    const { fetchAndStorePublicToken } = await import("./common/publicUtils");
    const publicToken = await fetchAndStorePublicToken();
    if (publicToken) setAuthToken(publicToken);
  }, [handleAuthEvent, setAuthToken]);

  // const navigate = useNavigate();
  const handleLogin = useCallback(
    async (username: string, password: string): Promise<string | null> => {
      let url = process.env.REACT_APP_SIMPLIFAI_BACKEND_API_URL + "/login";
      isDevEnvironment &&
        console.log("Sending login request for user", username, "to", url);
      openSpinnerHandler();
      try {
        const requestId = uuidv4();
        const res = await axios.post(url, {
          username,
          password,
          requestId: requestId,
        });
        if (res.data.success && res.data.requestId === requestId) {
          switchToUserSession(res.data.token, res.data.user_id, {
            email: res.data.email,
            firstname: res.data.firstname,
            lastname: res.data.lastname,
            refresh_token: res.data.refresh_token,
            auth_provider: res.data.auth_provider || "email",
            has_accepted_terms: res.data.has_accepted_terms === true,
          });
          return res.data.user_id;
        } else {
          isDevEnvironment && console.log("Authentication failed");
          closeSpinnerHandler();
          return null;
        }
      } catch (err) {
        closeSpinnerHandler();
        if (axios.isAxiosError(err) && err.response) {
          setShowToastr({
            show: true,
            type: "error",
            text: err.response.data?.message,
          });
          console.error("Server responded with an error", err.response);
        } else if (axios.isAxiosError(err)) {
          setShowToastr({
            show: true,
            type: "error",
            text: err.message || "Network error",
          });
          console.error("Network/CORS error", err.message);
        } else {
          console.error("Something went wrong", err);
        }
        return null; // Returning null to indicate an error occurred
      }
    },
    [
      setShowToastr,
      switchToUserSession,
      openSpinnerHandler,
      closeSpinnerHandler,
    ],
  );

  const handleGoogleLogin = useCallback(
    async (code: string): Promise<string | null> => {
      let url =
        process.env.REACT_APP_SIMPLIFAI_BACKEND_API_URL + "/auth/google";
      openSpinnerHandler();
      try {
        const res = await axios.post(url, {
          code,
        });
        if (res.data.success) {
          switchToUserSession(res.data.token, res.data.user_id, {
            email: res.data.email,
            firstname: res.data.firstname,
            lastname: res.data.lastname,
            refresh_token: res.data.refresh_token,
            auth_provider: res.data.auth_provider || "google",
            has_accepted_terms: res.data.has_accepted_terms === true,
          });
          return res.data.user_id;
        } else {
          const errorMessage =
            res.data.message || "Google authentication failed";
          isDevEnvironment &&
            console.log("Google authentication failed:", errorMessage);
          closeSpinnerHandler();
          setShowToastr({
            show: true,
            type: "error",
            text: errorMessage,
          });
          throw new Error(errorMessage);
        }
      } catch (err: any) {
        closeSpinnerHandler();
        if (err.response) {
          const errorMessage =
            err?.response?.data?.message || "Google authentication failed";
          setShowToastr({
            show: true,
            type: "error",
            text: errorMessage,
          });
          console.error("Server responded with an error", err.response);
          // Throw the error so SignInPage can catch and display it
          throw new Error(errorMessage);
        } else {
          console.error("Something went wrong with Google auth", err);
          throw new Error("Google authentication failed");
        }
      }
    },
    [
      setShowToastr,
      switchToUserSession,
      openSpinnerHandler,
      closeSpinnerHandler,
    ],
  );

  const handleGithubLogin = useCallback(
    async (code: string): Promise<string | null> => {
      let url =
        process.env.REACT_APP_SIMPLIFAI_BACKEND_API_URL + "/auth/github";
      const redirectUri =
        process.env.REACT_APP_AWS_COGNITO_REDIRECT_URI || `${window.location.origin}/login`;
      openSpinnerHandler();
      try {
        const res = await axios.post(url, {
          code,
          redirect_uri: redirectUri,
        });
        if (res.data.success) {
          switchToUserSession(res.data.token, res.data.user_id, {
            email: res.data.email,
            firstname: res.data.firstname,
            lastname: res.data.lastname,
            refresh_token: res.data.refresh_token,
            auth_provider: res.data.auth_provider || "github",
            has_accepted_terms: res.data.has_accepted_terms === true,
          });
          return res.data.user_id;
        } else {
          const errorMessage =
            res.data.message || "Github authentication failed";
          isDevEnvironment &&
            console.log("Github authentication failed:", errorMessage);
          closeSpinnerHandler();
          setShowToastr({
            show: true,
            type: "error",
            text: errorMessage,
          });
          throw new Error(errorMessage);
        }
      } catch (err: any) {
        closeSpinnerHandler();
        if (err.response) {
          const errorMessage =
            err?.response?.data?.message || "Github authentication failed";
          setShowToastr({
            show: true,
            type: "error",
            text: errorMessage,
          });
          console.error("Server responded with an error", err.response);
          throw new Error(errorMessage);
        } else {
          console.error("Something went wrong with Github auth", err);
          throw new Error("Github authentication failed");
        }
      }
    },
    [
      setShowToastr,
      switchToUserSession,
      openSpinnerHandler,
      closeSpinnerHandler,
    ],
  );

  const handleAcceptTerms = useCallback(async () => {
    if (isAcceptingTerms) return;

    setIsAcceptingTerms(true);
    try {
      const res = await acceptTerms();
      if (res.data.success && res.data.has_accepted_terms) {
        writeHasAcceptedTermsToStorage(true);
        setHasAcceptedTerms(true);
        closeSpinnerHandler();
        return;
      }

      setShowToastr({
        show: true,
        type: "error",
        text: res.data.message || "Failed to accept terms. Please try again.",
      });
    } catch (err) {
      console.error("Failed to accept terms:", err);
      setShowToastr({
        show: true,
        type: "error",
        text: "Failed to accept terms. Please try again.",
      });
    } finally {
      setIsAcceptingTerms(false);
    }
  }, [closeSpinnerHandler, isAcceptingTerms, setShowToastr]);

  // async function handleSignup(
  //   email: string,
  //   password: string,
  //   firstName: string,
  //   lastName: string
  // ): Promise<string | null> {
  //   let url = process.env.REACT_APP_SIMPLIFAI_BACKEND_API_URL + "/signup";
  //   try {
  //     const res = await axios.post(url, {
  //       email,
  //       password,
  //       first_name: firstName,
  //       last_name: lastName,
  //     });

  //     if (res.data.success) {
  //       localStorage.setItem("JMLAuthToken", res.data.token);
  //       localStorage.setItem("JMLRefreshToken", res.data.refresh_token);
  //       localStorage.setItem("JMLFirstname", res.data.firstname);
  //       localStorage.setItem("JMLEmail", email);
  //       localStorage.setItem("JMLLastname", res.data.lastname);
  //       localStorage.setItem("userId", res.data.user_id);
  //       setAuthToken(res.data.token);
  //       setUserId(res.data.user_id);
  //       const socket = WebSocketInstance.getInstance();
  //       setSocket(socket);
  //       return res.data.user_id;
  //     } else {
  //       return null;
  //     }
  //   } catch (err) {
  //     setShowToastr({
  //       show: true,
  //       type: "error",
  //       text: err?.response?.data?.message || "Signup failed",
  //     });
  //     return null;
  //   }
  // }

  // async function handleNewSignup(
  //   email: string,
  //   password: string,
  //   firstName: string,
  //   lastName: string
  // ): Promise<string | null> {
  //   let url = process.env.REACT_APP_SIMPLIFAI_BACKEND_API_URL + "/"; //Add new API here for sign up
  //   try {
  //     const res = await axios.post(url, {
  //       email,
  //       password,
  //       firstname: firstName,
  //       lastname: lastName,
  //     });

  //     if (res.data.success) {
  //       localStorage.setItem("JMLAuthToken", res.data.token);
  //       localStorage.setItem("JMLRefreshToken", res.data.refresh_token);
  //       localStorage.setItem("JMLFirstname", res.data.firstname);
  //       localStorage.setItem("JMLLastname", res.data.lastname);
  //       localStorage.setItem("userId", res.data.user_id);
  //       setAuthToken(res.data.token);
  //       setUserId(res.data.user_id);
  //       const socket = WebSocketInstance.getInstance();
  //       setSocket(socket);
  //       return res.data.user_id;
  //     } else {
  //       return null;
  //     }
  //   } catch (err) {
  //     setShowToastr({
  //       show: true,
  //       type: "error",
  //       text: err?.response?.data?.message || "Signup failed",
  //     });
  //     return null;
  //   }
  // }
  // async function handleAdminRegister(
  //     adminUsername: string,
  //     adminPassword: string,
  //     command: string,
  //     uEmail: string,
  //     uPassword: string,
  //     uFirstName: string,
  //     uLastName: string,
  //   ): Promise<boolean> {
  //     try {
  //       isDevEnvironment &&
  //         console.log(
  //           "Sending request to backend to register user with email " +
  //             uEmail +
  //             " and command " +
  //             command,
  //         );
  //       const res = await axios.post(
  //         `${process.env.REACT_APP_SIMPLIFAI_BACKEND_API_URL}/adminregister`,
  //         {
  //           admin_user: adminUsername,
  //           admin_password: adminPassword,
  //           command: command,
  //           u_email: uEmail,
  //           u_password: uPassword,
  //           u_firstname: uFirstName,
  //           u_lastname: uLastName,
  //         },
  //       );
  //       isDevEnvironment && console.log(res.data.message);
  //       if (res.data.success) {
  //         return true;
  //       } else {
  //         return false;
  //       }
  //     } catch (err) {
  //       isDevEnvironment && console.log(err);
  //       setShowToastr({
  //         show: true,
  //         type: "error",
  //         text: err?.response?.data?.error
  //           ? err?.response?.data?.error
  //           : err?.response?.data?.message,
  //       });
  //       return false; // returning false in case of an error
  //     }
  //   }


  async function handleRedriveIndexing(
    adminUsername: string,
    adminPassword: string,
    uEmail: string,
    projectId: string,
    activityId: string,
  ): Promise<boolean> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_SIMPLIFAI_BACKEND_API_URL}/redriveindexing`,
        {
          admin_user: adminUsername,
          admin_password: adminPassword,
          u_email: uEmail,
          project_id: projectId,
          activity_id: activityId,
        },
      );
      if (res.data.success) {
        isDevEnvironment && console.log("Redrove indexing successfully");
        return true;
      } else {
        return false;
      }
    } catch (err) {
      isDevEnvironment && console.log(err);
      return false; // returning false in case of an error
    }
  }

  const logoutHandler = useCallback(() => {
    // WARNING: Required for CloudWatch RUM user logout and session tracking. Do not remove logoutRumTracker function
    logoutRumTracker();

    // Fire-and-forget backend logout; keep handler itself synchronous
    void (async () => {
      try {
        // Call backend logout API to disconnect sockets and clear session
        // Note: We use auth header but avoid refresh flow if unauthorized
        await api.post("/api/logout", {}, { skipAuthRefresh: true } as any);
        isDevEnvironment && console.log("Successfully logged out from backend");
      } catch (err) {
        console.error("Failed to logout from backend:", err);
      }
    })();

    localStorage.removeItem("JMLAuthToken");
    localStorage.removeItem("JMLRefreshToken");
    localStorage.removeItem("JMLFirstname");
    localStorage.removeItem("JMLLastname");
    localStorage.removeItem("JMLEmail");
    localStorage.removeItem("userId");
    localStorage.removeItem("authProvider");
    localStorage.removeItem("SESSION_TYPE");
    clearHasAcceptedTermsFromStorage();

    authSync.broadcast({ type: "FORCE_LOGOUT_PERSONAL" });
    handleAuthEvent({ type: "FORCE_LOGOUT_PERSONAL", timestamp: Date.now() });

    sessionStorage.clear();
    setSResponse({});
    setIsAuthenticated(false);
    setHasAcceptedTerms(false);
    setAuthToken(null);
    setUserId(null);
    setProjects([]);
    WebSocketInstance.getInstance().close();
    setSocket(null);
  }, [setUserId, setProjects, isDevEnvironment, handleAuthEvent]);

  useEffect(() => {
    setLogoutHandler(() => logoutHandler);
  }, [logoutHandler, setLogoutHandler]);

  // The REST and socket layers raise this when the session can no longer be renewed (the refresh
  // token itself is expired or invalid). Prompt for a re-login instead of clearing state silently.
  useEffect(() => {
    return onSessionDisconnected(() => setShowSessionDisconnected(true));
  }, []);

  // teardown: logoutHandler is the canonical logout — the RUM logout signal, the cross-tab
  // FORCE_LOGOUT_PERSONAL broadcast, sessionStorage.clear() and the socket shutdown all live there.
  // Skipping it would leave other tabs rendered as authenticated and per-user sessionStorage intact
  // for the next login.
  // hardReload: the dead session has left stale state all over the tree (sockets, cached project
  // data, component state), so the login page has to come from a fresh document. forceLogout owns
  // the navigation — issuing one here as well would abort the load and blank the page.
  const handleSessionDisconnectedRelogin = useCallback(() => {
    setShowSessionDisconnected(false);
    forceLogout({ hardReload: true, teardown: logoutHandler });
  }, [logoutHandler]);

  useEffect(() => {
    if (socket !== null) {
      socket.addEventListener("force_logout", (event) => {
        setTimeout(logoutHandler, 2000);
      });
      socket.addEventListener("architecture", (event) => {
        isDevEnvironment && console.log("Received architecture");
        if ("aws" in event["architecture"]) {
          isDevEnvironment && console.log(event["architecture"]["aws"]);
          setSResponse(event["architecture"]["aws"]);
        } else if ("azure" in event["architecture"]) {
          isDevEnvironment && console.log(event["architecture"]["azure"]);
          setSResponse(event["architecture"]["azure"]);
        }
        setPromptFixed(true);
        setWaitingForResponse(false);
      });
    }
  }, [socket, isDevEnvironment, logoutHandler]);

  useEffect(() => {
    if (authToken !== null) {
      isDevEnvironment && console.log("Creating websocket instance");
      const socket = WebSocketInstance.getInstance();
      setSocket(socket);
    } else {
      setSocket(null);
    }
  }, [authToken, isDevEnvironment]);

  useEffect(() => {
    const checkAuthAndPublic = async () => {
      if (!LOGIN_ENABLED) {
        // No backend to validate tokens or open sockets: treat every visitor as signed out.
        setAuthToken(null);
        setIsAuthenticated(false);
        return;
      }
      let JMLAuthToken = localStorage.getItem("JMLAuthToken");
      let JMLPublicToken = localStorage.getItem("JMLPublicToken");
      let userId = localStorage.getItem("userId");

      const path = window.location.pathname;
      const canvasMatch = path.match(/\/canvas\/([^/]+)/);
      const slugOrIdFromUrl = canvasMatch ? canvasMatch[1] : null;

      const { isPublicSlug } = await import("./common/publicUtils");
      const isPublic = slugOrIdFromUrl ? isPublicSlug(slugOrIdFromUrl) : false;

      if (isPublic && JMLAuthToken) {
        await switchToPublicSession();
        return; // switchToPublicSession handles the redirect/reload if needed
      }

      if (JMLAuthToken && JMLAuthToken !== "") {
        localStorage.setItem("SESSION_TYPE", "USER");
        setAuthToken(JMLAuthToken);
        setIsAuthenticated(true);
        setHasAcceptedTerms(readHasAcceptedTermsFromStorage());
      } else {
        if (isPublic) {
          if (!JMLPublicToken) {
            const { fetchAndStorePublicToken } =
              await import("./common/publicUtils");
            JMLPublicToken = await fetchAndStorePublicToken();
          }
          if (JMLPublicToken) {
            localStorage.setItem("SESSION_TYPE", "PUBLIC");
            setAuthToken(JMLPublicToken);
          }
        } else {
          localStorage.removeItem("JMLPublicToken");
          localStorage.removeItem("JMLPublicTokenExpiry");
          setAuthToken(null);
        }
      }

      if (userId && userId !== "") {
        setUserId(userId);
      }
    };

    checkAuthAndPublic();
  }, [setUserId, location.pathname]);

  useEffect(() => {
    isDevEnvironment && console.log("Mounting App component");

    const unsubscribe = authSync.listen(handleAuthEvent);

    return () => {
      isDevEnvironment && console.log("Closing App component");
      unsubscribe();
    };
  }, [isDevEnvironment, handleAuthEvent]);

  // Inactivity logout with cross-tab sync via BroadcastChannel
  const inactivityTimeout = useInactivityTimeout({
    onForcedLogout: () => {
      const hasAuthToken = !!localStorage.getItem("JMLAuthToken");
      if (socket !== null) logoutHandler();
      window.location.href = hasAuthToken ? "/login" : "/open-source-projects";
    },
  });
  // Wire the hook's sync handler into the stable ref
  useEffect(() => {
    handleSyncEventRef.current = inactivityTimeout.handleSyncEvent;
  }, [inactivityTimeout.handleSyncEvent]);

  useEffect(() => {
    // Script for Rb2B to track website visitors. Find it here: https://support.rb2b.com/en/articles/9117086-how-to-add-rb2b-s-script-to-react-js
    (function () {
      var reb2b = (window.reb2b = window.reb2b || []);
      if (reb2b.invoked) return;
      reb2b.invoked = true;
      reb2b.methods = ["identify", "collect"];
      reb2b.factory = function (method: string) {
        return function () {
          var args = Array.prototype.slice.call(arguments);
          args.unshift(method);
          reb2b.push(args);
          return reb2b;
        };
      };
      for (var i = 0; i < reb2b.methods.length; i++) {
        var key = reb2b.methods[i];
        reb2b[key] = reb2b.factory(key);
      }
      reb2b.load = function (key: string) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src =
          "https://s3-us-west-2.amazonaws.com/b2bjsstore/b/" +
          key +
          "/reb2b.js.gz";
        var first = document.getElementsByTagName("script")[0];
        if (first && first.parentNode) {
          first.parentNode.insertBefore(script, first);
        }
      };
      reb2b.SNIPPET_VERSION = "1.0.1";
      reb2b.load("7N850HPWLLN1");
    })();
  }, [isDevEnvironment]);

  const onChangePassword = async (passwordObject: any) => {
    const requestId = uuidv4();
    const newObject = {
      old_password: passwordObject.OldPassword.value,
      new_password: passwordObject.ConfirmNewPassword.value,
      requestId: requestId,
    };
    try {
      const res = await api.post(`/change-password`, newObject);
      if (res.data.success && res.data.requestId === requestId) {
        setPasswordChangeResponse(res.data);
      }
    } catch (err: any) {
      if (err.response) {
        setShowToastr({
          show: true,
          type: "error",
          text: err?.response?.data?.message,
        });
        console.error("Server responded with an error:", err.response);
      } else {
        console.error("Something went wrong:", err);
      }
      setPasswordChangeResponse({
        ...passwordChangeResponse,
        message: err.response.data.message,
      });
    }
  };

  return (
    <div className="App">
      <div
        className={
          isAuthenticated && !hasAcceptedTerms
            ? "app-shell app-shell--terms-blocked"
            : "app-shell"
        }
      >
      {/* Global RUM page tracker – mount once */}
      {/* WARNING: Required for CloudWatch RUM route-level analytics. Do not remove these components */}
      {/* ClickRumTracker: Tracks the number of user clicks per route */}
      {/* PageTimeRumTracker: Tracks time spent by users on each route */}
      {/* PublicCanvasRumTracker: Tracks visits to public open-source `/canvas/:slug` routes */}
      <ClickRumTracker />
      <PageTimeRumTracker />
      <PublicCanvasRumTracker />

      <SessionTimeoutModal
        show={inactivityTimeout.showModal}
        onKeepAlive={inactivityTimeout.onKeepAlive}
        onLogoutNow={inactivityTimeout.onLogoutNow}
        expirationTime={inactivityTimeout.expirationTime}
      />

      <SessionDisconnectedModal
        show={showSessionDisconnected}
        onRelogin={handleSessionDisconnectedRelogin}
      />

      <VisibilityPersistence />
      <SpinnerLoader />
      <MaintenanceBanner />
      {shouldRedirectHomeWhileLoginDisabled(location.pathname) ? (
        // Login disabled (REACT_APP_LOGIN_ENABLED is not "true"): these routes need the backend, so send users home.
        <Navigate to="/" replace />
      ) : (
      <Routes>
        <Route path="/" element={<NewLandingPage />} />

        <Route
          path="/login"
          element={
            isAuthenticated && hasAcceptedTerms && !showSessionDisconnected ? (
              <Navigate to={loginRedirect} replace />
            ) : (
              <Suspense fallback={<RouteFallback />}>
                <SignInPage
                  onLogin={handleLogin}
                  onGoogleLogin={handleGoogleLogin}
                  onGithubLogin={handleGithubLogin}
                  redirectTo={loginRedirect}
                />
              </Suspense>
            )
          }
        />
        <Route
          path="/signup"
          element={
            <Suspense fallback={<RouteFallback />}>
              <SignupPage
                onGoogleLogin={handleGoogleLogin}
                onGithubLogin={handleGithubLogin}
              />
            </Suspense>
          }
        />
        <Route
          path="/confirm-signup"
          element={
            <Suspense fallback={<RouteFallback />}>
              <SignupConfirm />
            </Suspense>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <Suspense fallback={<RouteFallback />}>
              <ForgotPassword />
            </Suspense>
          }
        />
        <Route
          path="/reset-password"
          element={
            <Suspense fallback={<RouteFallback />}>
              <ResetPassword />
            </Suspense>
          }
        />

        {/* <Route path="/landing-page" element={<NewLandingPage />} /> */}
        <Route
          path="/demo"
          element={
            <Suspense fallback={<RouteFallback />}>
              <DemoPage />
            </Suspense>
          }
        />
        <Route
          path="/open-source-projects"
          element={
            <Suspense fallback={<RouteFallback />}>
              <OpenSourceProjects />
            </Suspense>
          }
        />
        <Route
          path="/open-source-projects/:slug"
          element={
            <Suspense fallback={<RouteFallback />}>
              <OpenSourceProjectPage />
            </Suspense>
          }
        />
        <Route
          path="/jigsaw-ai"
          element={
            <Suspense fallback={<RouteFallback />}>
              <JigsawAiPage />
            </Suspense>
          }
        />
        <Route
          path="/pricing"
          element={
            <Suspense fallback={<RouteFallback />}>
              <PricingPage />
            </Suspense>
          }
        />
        <Route
          path="/product"
          element={
            <Suspense fallback={<RouteFallback />}>
              <SWArchVisualizerProductPage />
            </Suspense>
          }
        />
        <Route
          path="/pull-request-helper"
          element={
            <Suspense fallback={<RouteFallback />}>
              <GithubAppProductPage />
            </Suspense>
          }
        />
        <Route
          path="/governance"
          element={
            <Suspense fallback={<RouteFallback />}>
              <GovernanceProductPage />
            </Suspense>
          }
        />
        <Route
          path="/ai-code-review"
          element={
            <Suspense fallback={<RouteFallback />}>
              <VibeCodeCheckProductPage />
            </Suspense>
          }
        />
        <Route
          path="/vibe-code-check"
          element={<Navigate to="/ai-code-review" replace />}
        />
        <Route
          path="/cloud-scanner"
          element={
            <Suspense fallback={<RouteFallback />}>
              <CloudScannerProductPage />
            </Suspense>
          }
        />

        {/* Note: Creating a copy of "cloud-scanner" to enable A/B testing for Google Ads. */}
        <Route
          path="/scanner-cloud"
          element={
            <Suspense fallback={<RouteFallback />}>
              <CloudScannerProductPage />
            </Suspense>
          }
        />

        <Route
          path="/cloud-scanner-userguide"
          element={
            <Suspense fallback={<RouteFallback />}>
              <CloudScannerUserGuide />
            </Suspense>
          }
        />

        {/* <Route path="/in-press" element={<InPress />} /> */}
        <Route
          path="/in-press"
          element={
            <Suspense fallback={<RouteFallback />}>
              <NewInPress />
            </Suspense>
          }
        />
        {/* <Route path="/blogs" element={<Blogs />} /> */}
        {/* <Route path="/blog-page" element={<NewBlogs />} /> */}
        {/* <Route path="/blog-page-1" element={<NewBlog1 />} /> */}
        {/* <Route path="/blog-page-2" element={<NewBlog2 />} /> */}
        {/* <Route path="/detail" element={<Details />} /> */}
        {/* <Route path="/brochure/cloudx" element={<BrochuresIndex />} /> */}
        {/* <Route path="/flyer/cloudx" element={<FlyersIndex />} /> */}
        {/* <Route path="/new-product" element={<NewArchProductPage />} /> */}
        {/* <Route path="/product" element={<ProductPage />} /> */}
        {/* <Route path="/msp" element={<NewProductPage />} /> */}
        <Route
          path="/start"
          element={
            <Suspense fallback={<RouteFallback />}>
              <StartPage />
            </Suspense>
          }
        />
        <Route
          path="/installer"
          element={
            !isLocalInstaller() && isCloudDB() ? (
              <Suspense fallback={<RouteFallback />}>
                <InstallerPage />
              </Suspense>
            ) : (
              <Suspense fallback={<RouteFallback />}>
                <PageNotFound />
              </Suspense>
            )
          }
        />
        <Route
          path="/installer/download-success"
          element={
            !isLocalInstaller() && isCloudDB() ? (
              <Suspense fallback={<RouteFallback />}>
                <InstallerDownloadSuccess />
              </Suspense>
            ) : (
              <Suspense fallback={<RouteFallback />}>
                <PageNotFound />
              </Suspense>
            )
          }
        />
        <Route
          path="/installer/download-error"
          element={
            !isLocalInstaller() && isCloudDB() ? (
              <Suspense fallback={<RouteFallback />}>
                <InstallerDownloadError />
              </Suspense>
            ) : (
              <Suspense fallback={<RouteFallback />}>
                <PageNotFound />
              </Suspense>
            )
          }
        />
        <Route
          path="/installer/download-general-error"
          element={
            !isLocalInstaller() && isCloudDB() ? (
              <Suspense fallback={<RouteFallback />}>
                <InstallerDownloadGeneralError />
              </Suspense>
            ) : (
              <Suspense fallback={<RouteFallback />}>
                <PageNotFound />
              </Suspense>
            )
          }
        />

        {/* <Route path="/product" element={<Navigate to="/sw-arch-visualizer" />} /> */}
        {/* <Route
          path="/adminregister"
          element={<AdminRegisterPage onLogin={handleAdminRegister} />}
        /> */}
        <Route
          path="/change-password"
          element={
            <RequireAuth>
              <Suspense fallback={<RouteFallback />}>
                <ChangePassword
                  onChangePassword={onChangePassword}
                  passwordChangeResponse={passwordChangeResponse}
                />
              </Suspense>
            </RequireAuth>
          }
        />
        <Route
          path="/redriveindexing"
          element={
            <Suspense fallback={<RouteFallback />}>
              <RedriveIndexingPage onLogin={handleRedriveIndexing} />
            </Suspense>
          }
        />
        <Route
          path="/dashboard"
          element={
            <RequireAuth>
              <Suspense fallback={<RouteFallback />}>
                <NewDashboard socket={socket} sandboxMode={false} />
              </Suspense>
            </RequireAuth>
          }
        />
        <Route
          path="/canvas/:pathProjectId?"
          element={
            <RequireAuth>
              <Suspense fallback={<RouteFallback />}>
                <NewSafeViewEditArchitecture
                  sResponse={sResponse ?? null}
                  qResponse={qResponse}
                  setSResponse={setSResponseSafe}
                  setQResponse={setQResponse}
                  descriptionId={descriptionId}
                  socket={socket}
                  loadingArch={loadingArch}
                  setLoadingArch={setLoadingArch}
                />
              </Suspense>
            </RequireAuth>
          }
        />
        <Route
          path="/sandbox"
          element={
            <RequireAuth>
              <Suspense fallback={<RouteFallback />}>
                <NewDashboard socket={socket} sandboxMode={true} />
              </Suspense>
            </RequireAuth>
          }
        />
        <Route
          path="*"
          element={
            <Suspense fallback={<RouteFallback />}>
              <PageNotFound />
            </Suspense>
          }
        />
      </Routes>
      )}
      </div>

      <TermsModal
        isOpen={isAuthenticated && !hasAcceptedTerms}
        mandatory
        isSubmitting={isAcceptingTerms}
        onClose={() => {}}
        onAccept={handleAcceptTerms}
      />
    </div>
  );
}

export default App;
